import My2NAppAccessDisabledIcon from './My2NAppAccessDisabledIcon';
import My2NAppAccessIcon from './My2NAppAccessIcon';

export { My2NAppAccessDisabledIcon, My2NAppAccessIcon };
